import _ from 'lodash';
export function sleep(timeout) {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, timeout);
    });
}
export function withLoading(self, p, useLoading = true) {
    if (!useLoading) {
        return p;
    }
    self.loading = true;
    return p.finally(() => {
        self.loading = false;
    });
}
export function withFieldLoading(self, p, field) {
    self[field] = true;
    return p.finally(() => {
        self[field] = false;
    });
}
/** 控制多个 loading */
export function withFieldMutipleLoading(self, p, fields) {
    _.forEach(fields, (key) => {
        self[key] = true;
    });
    return p.finally(() => {
        _.forEach(fields, (key) => {
            self[key] = false;
        });
    });
}
export class TaskSource {
    constructor() {
        this._fired = false;
        this._promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get Promise() {
        return this._promise;
    }
    Resolve(t) {
        if (this._fired) {
            console.error('Can not Resolve fired source');
            return;
        }
        this._fired = true;
        this._resolve(t);
    }
    // todo
    TryResolve(t) {
        if (this._fired) {
            return false;
        }
        this.Resolve(t);
    }
    Reject(e) {
        if (this._fired) {
            console.error('Can not Resolve fired source');
            return;
        }
        this._fired = true;
        this._reject(e);
    }
    get Fired() {
        return this._fired;
    }
}
export class LoadingController {
    constructor(vueThis) {
        this.promises = new Set();
        this.vueThis = {};
        this.vueThis = vueThis;
        this.vueThis.loading = true;
    }
    static withLoading(vueThis, p) {
        if (!vueThis.__loadingController) {
            vueThis.__loadingController = new LoadingController(vueThis);
        }
        vueThis.__loadingController.add(p);
        return p;
    }
    add(promise) {
        this.promises.add(promise);
        this.vueThis.loading = true;
        promise.finally(() => {
            this.promises.delete(promise);
            if (this.promises.size === 0) {
                this.vueThis.loading = false;
            }
        });
    }
    get isLoading() {
        return this.vueThis.loading;
    }
}
